<template lang="pug">
.contract-detail
  h2
    span 合同概况
  contract-stage-bar(v-if='!$media.isMobile', :contract='contract')
  auto-table(:defines='$defines.contract', unstackable, :data='contracts', :detail-view='true', :row-classes='record => record._id === contract._id ? "actived" : "inactive"')

  router-view

  template(v-if='!this.$route.meta.action')
    template(v-if='!$media.isMobile')
      h2 操作
      .actions
        .ui.statistics.buttonlike
          //.statistic.buttonlike(@click='goto_action("charge_lezhu")', v-if='$config.logic.lezhu_meter && $permission.has("basic.create.charges")')
            .value: i.mi loupe
            .label 乐住智能电表

          // 手动抄表
          template(v-if='$config.logic.manual_meter && $permission.has("basic.create.charges")')
            .statistic.buttonlike(@click='goto_room_action("utilities")')
              .value: i.mi opacity
              .label 水电抄表
            .statistic.buttonlike(@click='goto_action("utilities_settle")')
              .value: i.mi invert_colors
              .label 结算水电

          .statistic.buttonlike(@click='goto_action("charge")', v-if='$permission.has("basic.create.charges")')
            .value: i.mi opacity
            .label 水电费充值

          template(v-if='contract.state === "active"')
            template(v-if='contract.date_expire < contract.date_end')
              .statistic.buttonlike(@click='goto_action("rent")', v-if='$permission.has("basic.create.rents")')
                .value: i.mi event_note
                .label 续交租金

            template(v-else)
              .statistic.buttonlike.disabled
                .value: i.mi event_available
                .label 租金已付清

              template(v-if='!contract.rent_by_day')
                .statistic.buttonlike(@click='goto_renew', v-if='$permission.has("basic.create.contracts")')
                  .value: i.mi add_box
                  .label 续签合同

            .statistic.buttonlike(@click='goto_action("rent_by_day")', v-if='$permission.has("basic.create.rents")')
              .value: i.mi event
              .label 按日交租

            .statistic.buttonlike(@click='preorderable()', :class='{disabled:!$permission.has("basic.modify.contracts.preorderable")}')
              .value: i.mi {{ ['help_outline', 'room', 'check'][contract.preorderable || 0] }}
              .label {{ ['预定情况未知', '可预订', '确认续租'][contract.preorderable || 0] }}

            .statistic.buttonlike(@click='goto_action("transfer_delegation")', v-if='days_to_expired > 0 && $permission.has("basic.create.transfer_delegations")')
              .value: i.mi transform
              .label 签署转让委托

            .statistic.buttonlike(@click='contract_checkout', v-if='$permission.has("basic.modify.contracts.checkout")')
              .value: i.mi exit_to_app
              .label 退房

          template(v-else-if='delegated')
            .statistic.buttonlike(@click='contract_checkout', v-if='$permission.has("basic.modify.contracts.checkout")')
              .value: i.mi exit_to_app
              .label 退房

          template(v-else)
            .statistic.buttonlike.disabled
              .value: i.mi exit_to_app
              .label 已退房

        .ui.basic.button.grey.labeled.icon.hide-in-mobile(@click='contract_recall', v-if='$permission.has("basic.recall.contracts")')
          i.icon.warning
          | 撤销合同

        .ui.basic.button.grey.labeled.icon.hide-in-mobile(@click='contract_repair', v-if='$permission.has("basic.modify.contracts.repair")')
          i.icon.warning
          | 修復合同

        .ui.basic.button.grey.labeled.icon.hide-in-mobile(@click='cancel_transfer_delegation()' v-if='delegated && $permission.has("basic.create.transfer_delegations")')
          i.icon.warning
          | 取消转让委托

    template(v-if='customers.length && $permission.has("basic.view.customers")')
      h3
      form-room-customers(:no='no', :contract='contract', :customers='customers')

    template(v-if='rents && $permission.has("basic.view.rents")')
      h2 租金记录
      auto-table(:defines='$defines.rent', unstackable, :data='rents', :detail-view='true')

    template(v-if='charges && $permission.has("basic.view.charges")')
      h2 水电充值记录
      auto-table(:defines='$defines.charge', unstackable, :data='charges', :detail-view='true', layout='in_room')

</template>

<script>
import { AutoTable, AutoEditTable } from '../auto'
import { DialogCustomers, FormRoomCustomers } from '../forms'
import { ContractStageBar } from '../basic'

export default {
  name: 'contract-detail',
  props: ['no', 'contract_id', 'action'],
  components: {
    AutoEditTable,
    AutoTable,
    ContractStageBar,
    DialogCustomers,
    FormRoomCustomers,
  },
  computed: {
    room() {
      return this.$store.getters.room(this.no)
    },
    customers() {
      if (this.contract && this.contract._customers)
        return this.$store.getters.customers_filter(this.contract._customers)
      return []
    },
    stored_contract() {
      return this.$store.getters.contract(this.contract_id) || {}
    },
    days_to_expired() {
      return this.$moment.daysBetween(
        this.$moment(this.contract.date_expire).startOf('days'),
        this.$moment().startOf('days')
      )
    },
    delegated() {
      return this.contract && this.contract.state === 'delegated'
    },
  },
  data() {
    return {
      contract: {},
      contracts: [],
      rents: [],
      charges: [],
    }
  },
  watch: {
    $route() {
      if (!this.action)
        this.load()
    },
  },
  created() {
    this.$doc.title = this.no
    this.contract = this.$store.getters.contract(this.contract_id) || {}
    this.load()
  },
  methods: {
    load() {
      this.$http.get(`contracts/${this.contract_id}/details`)
        .then(r => {
          const { contract, relatives, charges, rents } = r.body
          this.contract = contract
          this.contracts = relatives
          this.charges = charges
          this.rents = rents
        })
        .catch(this.$utils.DefaultErrorHandler.bind(this))
    },
    goto_action(action) {
      this.$router.push(`/room/${this.no}/contract/${this.contract_id}/${action}`)
    },
    goto_room_action(action) {
      this.$router.push(`/room/${this.no}/${action}`)
    },
    goto_renew() {
      this.$router.push(`/room/${this.no}/sign/renew/${this.contract_id}`)
    },
    contract_active() {
      this.$http.put(`contracts/${this.contract_id}/active`, { active: true })
        .then(r => {
          this.contract = r.body.data
        })
        .catch(this.$utils.DefaultErrorHandler.bind(this))
    },
    contract_checkout() {
      this.goto_action('checkout')
    },
    contract_recall() {
      if (confirm('确定?')) {
        this.$http.delete(`contracts/${this.contract_id}/recall`, { recall: true })
          .then(r => {
            this.$store.dispatch('load_summary', this)
            this.$router.push('/')
          })
          .catch(this.$utils.DefaultErrorHandler.bind(this))
      }
    },
    cancel_transfer_delegation() {
       if (confirm('确定取消委託?')) {
        this.$http.delete(`contracts/${this.contract_id}/transfer_delegation`)
          .then(r => {
            this.$store.dispatch('load_summary', this)
          })
          .catch(this.$utils.DefaultErrorHandler.bind(this))
      }
    },
    contract_repair() {
      if (confirm('确定?')) {
        this.$http.put(`contracts/${this.contract_id}/repair`)
          .then(r => {
            this.$store.dispatch('load_summary', this)
          })
          .catch(this.$utils.DefaultErrorHandler.bind(this))
      }
    },
    update_contract(key, value) {
      this.$set(this.contract, key, value)
      this.$set(this.stored_contract, key, value)
    },
    preorderable() {
      let preorderable = this.contract.preorderable || 0
      preorderable++
      const state_bound = this.contract.rent_by_day ? 1 : 2
      if (preorderable > state_bound)
        preorderable = 0
      this.$http.put(`contracts/${this.contract._id}/preorderable`, { preorderable })
        .then(r => {
          this.update_contract('preorderable', r.body.preorderable || 0)
        })
        .catch(this.$utils.DefaultErrorHandler.bind(this))
    },
  },
}
</script>



// WEBPACK FOOTER //
// ContractDetail.vue?546e8388